"use client";

import { useQuery } from "@tanstack/react-query";
import { useBackend } from "./useBackend";

/**
 * Hook for fetching all video jobs in a group.
 * Data is considered stale after 20 seconds.
 */
export function useVideoGroup(groupId: string | undefined) {
  const backend = useBackend();

  return useQuery({
    queryKey: ["video-group", groupId],
    queryFn: () => backend.video.listGroup(groupId!),
    enabled: !!groupId,
    staleTime: 20_000,
  });
}
